import { useContext, useEffect, useState } from 'react';

import { AppRoute, SidebarMenuItem, UserRole } from '../types/enums';
import { UserContext } from '../App';

const useMenuItems = () => {
  const { user } = useContext(UserContext);
  const [items, setItems] = useState<
    Partial<Record<SidebarMenuItem, { name: string; url: string }>>
  >({
    [SidebarMenuItem.DASHBOARDS]: { name: 'dashboards', url: AppRoute.DASHBOARDS },
    [SidebarMenuItem.WEBSITES]: { name: 'websites', url: AppRoute.WEBSITES },
    [SidebarMenuItem.UPGRADE]: { name: 'plans', url: AppRoute.UPGRADE }
  });

  useEffect(() => {
    if (user && user.role === UserRole.ADMIN) {
      setItems({
        [SidebarMenuItem.DASHBOARDS]: { name: 'dashboards', url: AppRoute.DASHBOARDS },
        [SidebarMenuItem.WEBSITES]: { name: 'websites', url: AppRoute.WEBSITES },
        [SidebarMenuItem.UPGRADE]: { name: 'plans', url: AppRoute.UPGRADE },
        [SidebarMenuItem.USER_MANAGEMENT]: { name: 'backoffice', url: AppRoute.USERS }
      });
    }
  }, [user]);

  return items;
};

export default useMenuItems;
